import { connect } from 'react-redux';

import { VillageMap } from './VillageMap';
import { EMapTypes } from '../../constants/map';
import { IState } from '../../store';
import { searchMapInfrastructure, setMapType } from '../../store/map';
import { TInfrastructureBbox, TIOSMInfrastructure } from '../../types';
import { TTypedThunkDispatch } from '../../types/store';

interface ICoordinates {
  lat: number;
  lng: number;
}

export interface IVillageMapStoreProps {
  coordinates: ICoordinates;
  infrastructureList: TIOSMInfrastructure[];
  yandexApiKeySatellite?: string | null;
  mapType: EMapTypes;
}

export interface IVillageMapDispatchProps {
  searchInfrastructures(bbox: [[number, number], [number, number]]): void;
  setMapType(mapType: EMapTypes): void;
}

export function mapStateToProps(state: IState): IVillageMapStoreProps {
  return {
    coordinates: state.villageData.village.coordinates,
    infrastructureList: state.map.infrastructureList,
    yandexApiKeySatellite: state.map.yandexApiKeySatellite,
    mapType: state.map.mapType,
  };
}

export function mapDispatchToProps(dispatch: TTypedThunkDispatch): IVillageMapDispatchProps {
  return {
    searchInfrastructures: (bbox: TInfrastructureBbox) => {
      dispatch(searchMapInfrastructure(bbox));
    },
    setMapType(mapType: EMapTypes) {
      dispatch(setMapType(mapType));
    },
  };
}

export const VillageMapContainer = connect<IVillageMapStoreProps, IVillageMapDispatchProps>(
  mapStateToProps,
  mapDispatchToProps,
)(VillageMap);
